import { TooltipController } from './chunk-BSU4PWFL.js';
import { menuContext } from './chunk-HSL7QSWM.js';
import { FocusVisibleController } from './chunk-LOFOQRT3.js';
import { useContext, effect } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var MenuButton = class extends Component {
  constructor(instance) {
    super(instance);
    this.z = useContext(menuContext);
    new FocusVisibleController(instance);
    new TooltipController(instance);
  }
  onAttach(el) {
    this.z.Nc(el);
    effect(this.qc.bind(this));
  }
  onConnect(el) {
    const hint = Array.from(el.querySelectorAll('[slot="hint"]')).pop();
    if (hint)
      effect(() => void (hint.textContent = this.z.ab()));
  }
  qc() {
    this.z.Pc(this.$props.disabled());
  }
};
MenuButton.el = defineElement({
  tagName: "media-menu-button",
  props: { disabled: false }
});

export { MenuButton };
